import type { Backend } from "@tento-lona/sheets";

/**
 * A sheets `Backend` for an owner that has no rows side of its own: every
 * read and write rejects, and every subscription throws, with an error naming
 * `owner`. A `parseSheet` preview with only a cell backend, or an ephemeral
 * sheet's seeded backend, holds one, so a keyed read reaches no server it was
 * not given rather than the client's real rows backend.
 */
export function unreachableSheetsBackend(owner: string): Backend {
  const refuse = (method: string): Error =>
    new Error(`${owner}: has no sheets backend; \`${method}\` is not served here`);
  const reject = (method: string): Promise<never> => Promise.reject(refuse(method));
  return {
    fetchSheet: () => reject("fetchSheet"),
    fetchCells: () => reject("fetchCells"),
    fetchCellsByKey: () => reject("fetchCellsByKey"),
    fetchSheetCells: () => reject("fetchSheetCells"),
    fetchCellsBatch: () => reject("fetchCellsBatch"),
    onRowChange: () => {
      throw refuse("onRowChange");
    },
    onCellChange: () => {
      throw refuse("onCellChange");
    },
    writeCell: () => reject("writeCell"),
    clearCell: () => reject("clearCell"),
    writeTimepointCell: () => reject("writeTimepointCell"),
    clearTimepointCell: () => reject("clearTimepointCell"),
    addRow: () => reject("addRow"),
    updateRow: () => reject("updateRow"),
    deleteRow: () => reject("deleteRow"),
  };
}
